import { withAuthor } from "@cirrus/core/http/url/withAuthor"
import { withBase } from "@cirrus/core/http/url/withBase"
import { markingRolesEnum as markingRoles } from "@cirrus/routing/author/routeHelper"
import { routeTemplates } from "@cirrus/routing/author/routeTemplates"
import { routeTemplates as deliveryRouteTemplates } from "@cirrus-delivery/v1/router/routeTemplates"

function getMarkingRole(role) {
  switch (role) {
    case "MARKER":
      return markingRoles.assessing

    case "MODERATOR":
      return markingRoles.moderation

    default:
      return null
  }
}

export function getLink(result) {
  switch (result.redirect_to_type) {
    case "marking_assess":
      return withAuthor(
        `author/app#${routeTemplates.markingItem.build({
          scheduleId: result.schedule_id,
          markingRole: getMarkingRole(result.assessor_role),
          tab: "submissions"
        })}`
      )

    case "exam_attempt":
      return withBase(
        `/app#${deliveryRouteTemplates.keycodeStart.build(
          result.schedule_id
        )}?loggedInByKeycode=true`,
        "/delivery"
      )

    case "review_session":
      return withBase(
        `/app#${deliveryRouteTemplates.results.build(
          result.schedule_id,
          result.attempt_id,
          "reviewSession",
          "?loggedInByKeycode=true"
        )}`,
        "/delivery"
      )

    default:
      return withAuthor("author/app")
  }
}
